import {
  createUniversalReporter,
  createSemanticMetrics,
} from '@spotify-internal/semantic-metrics';
import { createRouteMetrics } from '@spotify-internal/next-router-metrics';

const { sendMetric } = createSemanticMetrics({
  key: 'www-referrals',
  reporter: createUniversalReporter(),
  // uncomment if the key is not the same as your component_id
  // component_id: 'www-referrals',
});

const withRouteMetrics = createRouteMetrics(sendMetric);

export { sendMetric, withRouteMetrics };
